module.exports = __webpack_public_path__ + "img/titanium-plate.bdc99ffe.png";